/**
 * @generated SignedSource<<7b719b9cd30d350feb06c1a20dc00797>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type providerQueryQuery$variables = Record<PropertyKey, never>;
export type providerQueryQuery$data = {
  readonly apiKey: ReadonlyArray<{
    readonly autoConfirmOrders: boolean;
    readonly clientId: number;
    readonly descriptionKey: string | null;
    readonly id: string;
    readonly invitionPhoneNumber: string | null;
    readonly printfulPrefix: string | null;
    readonly printfulSuffix: string | null;
    readonly providerId: number;
    readonly secretKey: string | null;
    readonly statusId: number;
  } | null> | null;
};
export type providerQueryQuery = {
  response: providerQueryQuery$data;
  variables: providerQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProviderApiKeyDto",
    "kind": "LinkedField",
    "name": "apiKey",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "autoConfirmOrders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "descriptionKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secretKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "printfulPrefix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "printfulSuffix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invitionPhoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "providerQueryQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "providerQueryQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "2d87f18d0fba0e21fc13a252b244d541",
    "id": null,
    "metadata": {},
    "name": "providerQueryQuery",
    "operationKind": "query",
    "text": "query providerQueryQuery {\n  apiKey {\n    clientId\n    autoConfirmOrders\n    descriptionKey\n    id\n    providerId\n    secretKey\n    statusId\n    printfulPrefix\n    printfulSuffix\n    invitionPhoneNumber\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0955dcf7a990cb1ea1b3f45ac7bdab0";

export default node;
